/**
 * i18n — Polski (pl) ✅ COMPLETE
 */

const pl = {
  appTitle: 'Tarkov Money Maker 2',
  modeBadgePvp: 'PvP',
  modeBadgePve: 'PvE',
  modeBadgeSeason: 'Sezon 1',
  loading: 'Ładowanie',
  filterSearchLabel: 'Szukaj',
  filterSearchPlaceholder: 'Nazwa przedmiotu, Enter lub klik…',
  filterSearchAddTerm: 'Dodaj kolejny termin…',
  filterSearchAdd: 'dodaj',
  filterProfitLabel: 'Min. zysk',
  filterLevelLabel: 'Poziom gracza',
  filterOffersLabel: 'Min. oferty',
  filterOffersDisabled: 'API nie dostarcza liczby ofert w tym trybie. Filtr wyłączony.',
  traderEnable: 'włącz',
  traderDisable: 'wyłącz',
  intelNotBuilt: 'Nie zbudowane',
  intelLevel1: 'Poziom 1',
  intelLevel2: 'Poziom 2',
  intelLevel3: '-30% opłata flea',
  colItem: 'Przedmiot',
  colBuyTrader: 'Zakup u Tradera',
  colSellTrader: 'Sprzedaż u Tradera',
  colAction: 'Akcja',
  colBestProfit: '★ Najlepszy zysk',
  colTraderFlea: 'Trader→Flea',
  colFleaTrader: 'Flea→Trader',
  colFlea: 'Flea',
  copyToast: 'Skopiowano!',
  tooltipBuyPrices: 'Ceny zakupu u traderów',
  tooltipSellPrices: 'Ceny sprzedaży',
  flea24h: 'Flea — 24h',
  fleaCur: 'Aktualna',
  fleaLow: 'Min. 24h',
  fleaAvg: 'Śr. 24h',
  fleaHigh: 'Maks. 24h',
  fleaOffers: 'oferty',
  recFTS: 'Kup Flea → Sprzedaj Traderowi',
  recBTF: 'Kup u Tradera → Sprzedaj Flea',
  cardBuy: 'Zakup',
  cardSell: 'Sprzedaż',
  cardOffers: 'oferty',
  paginationOf: 'z',
  paginationPerPage: 'Na stronę:',
  paginationPage: 'Strona',
  paginationTapSort: 'Kliknij, aby sortować',
  noItems: 'Nie znaleziono opłacalnych przedmiotów. Obniż próg lub aktywuj więcej traderów.',
  chartTitle: 'Flea — migawka 24h',
  chartNoData: 'Niewystarczające dane',
  apiStatusTitle: 'Status synchronizacji',
  apiStatusOnline: 'tarkov.dev Online',
  apiStatusDegraded: 'tarkov.dev Obniżona wydajność',
  apiStatusOffline: 'tarkov.dev Offline',
  apiStatusChecking: 'Sprawdzanie…',
  apiStatusGlobal: 'Status globalny',
  apiStatusLastSync: 'Ostatnia sync',
  apiStatusItems: 'Zsynchronizowane przedmioty',
  apiStatusItemsSub: 'łącznie skumulowane',
  apiStatusSource: 'Źródło API',
  apiStatusSourceSub: 'auto-sprawdzanie co 30s',
  apiStatusCheckedAt: 'Sprawdzono',
  apiStatusModeStatus: 'Status',
  apiStatusModeItems: 'Przedmioty',
  apiStatusModeLastSync: 'Ostatnia sync',
  apiStatusModeDuration: 'Czas trwania',
  apiStatusNever: 'nigdy',
  apiStatusJustNow: 'przed chwilą',
  apiStatusTimeAgoPrefix: '',
  apiStatusMinutesAgo: 'min temu',
  apiStatusHoursAgo: 'h temu',
  apiStatusRest: 'REST',
  exportCSV: 'Eksportuj CSV',
  exportJSON: 'Eksportuj JSON',
  histFleaPrice: 'Cena Flea — ostatnie 24h',
  histOffers: 'Oferty — ostatnie 24h',
  histLoading: 'Ładowanie historii…',
  histNoData: 'Brak danych historycznych — gromadzą się po każdej synchronizacji.',
  histError: 'Serwer niedostępny — historia będzie dostępna po uruchomieniu backendu.',
};

export default pl;
